// src/components/ui/FilterToolbar.jsx

import React from 'react';
import Button from './Button';
import RefreshButton from './RefreshButton';
import {
  PAGE,
  getToolbarStyle,
  getSearchInputStyle,
  getDateInputStyle,
} from './pageTheme';

export default function FilterToolbar({
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Search…',
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
  dateMin,
  dateMax,
  dateLabel = 'Date',
  showClear,
  onClear,
  refreshing,
  onRefresh,
  actions,
}) {
  return (
    <div
      style={{
        ...getToolbarStyle(),
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap',
        width: '100%',
        padding: '10px 12px',
        boxSizing: 'border-box',
      }}
    >
      <input
        type="text"
        value={searchValue || ''}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder={searchPlaceholder}
        style={{
          ...getSearchInputStyle(),
          flex: '1 1 220px',
          minWidth: 170,
          height: 34,
          padding: '0 10px',
          fontSize: 12,
        }}
      />

      <span
        style={{
          ...PAGE.type.label,
          fontSize: 11,
          whiteSpace: 'nowrap',
          flexShrink: 0,
        }}
      >
        {dateLabel}
      </span>

      <input
        type="date"
        value={dateFrom || ''}
        onChange={(e) => onDateFromChange(e.target.value)}
        min={dateMin}
        max={dateMax}
        style={{
          ...getDateInputStyle(),
          width: 128,
          height: 34,
          padding: '0 8px',
          fontSize: 12,
          flexShrink: 0,
        }}
      />

      <span
        style={{
          ...PAGE.type.label,
          fontSize: 11,
          whiteSpace: 'nowrap',
          flexShrink: 0,
        }}
      >
        to
      </span>

      <input
        type="date"
        value={dateTo || ''}
        onChange={(e) => onDateToChange(e.target.value)}
        min={dateMin}
        max={dateMax}
        style={{
          ...getDateInputStyle(),
          width: 128,
          height: 34,
          padding: '0 8px',
          fontSize: 12,
          flexShrink: 0,
        }}
      />

      {showClear && (
        <Button
          variant="outline"
          size="sm"
          onClick={onClear}
          style={{
            height: 34,
            padding: '0 10px',
            fontSize: 11,
            fontWeight: 700,
            whiteSpace: 'nowrap',
            flexShrink: 0,
          }}
        >
          Clear
        </Button>
      )}

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          flexShrink: 0,
          marginLeft: 'auto',
        }}
      >
        <RefreshButton refreshing={refreshing} onClick={onRefresh} />

        {actions && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexShrink: 0,
            }}
          >
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}